export interface Image {
  id: string;
  uri: string;
  checksum: string;
  contentType: string;
  altText?: string;
}

export default Image;
